import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const EmptyState: FunctionComponent<Props> = ({
    className = '',
    compact,
    description,
    heading,
    icon,
    testId = TEST_ID
}) => (
    <div
        className={`${styles.emptyState}${compact ? ` ${styles.compact}` : ''} ${className}`}
        data-testid={testId}
    >
        {!compact && icon && <div className={styles.icon}>{icon}</div>}

        <h3 className={styles.heading}>{heading}</h3>

        {description && <p className={styles.description}>{description}</p>}
    </div>
);

export default EmptyState;
